const CHAT_ROUTE_ALIASES: Record<string, string> = {
  "/dashboard": "/",
  "/requests": "/epic-requests",
};

export function normalizeChatRoute(path: string): string {
  const stripped = path.replace(/\/$/, "") || "/";
  return CHAT_ROUTE_ALIASES[stripped] ?? stripped;
}
